import { createContext } from 'react';
import type { Tenant } from '@/types';

export type TenantErrorType =
  | 'not_found'
  | 'invalid_subdomain'
  | 'network'
  | 'unknown';

export interface TenantError {
  type: TenantErrorType;
  message: string;
}

export interface TenantState {
  tenant: Tenant | null;
  slug: string;
  isLoading: boolean;
  error: TenantError | null;
  retry: () => void;
}

export const TenantContext = createContext<TenantState | null>(null);
